"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeLogType = void 0;
var IkeLogType;
(function (IkeLogType) {
    IkeLogType["SERVER"] = "server";
    IkeLogType["CLI"] = "cli";
    IkeLogType["BOT"] = "bot";
    IkeLogType["FUNCTION"] = "function";
    IkeLogType["CONSOLE"] = "console";
    IkeLogType["CLIENT"] = "client";
})(IkeLogType || (exports.IkeLogType = IkeLogType = {}));
//# sourceMappingURL=log.types.js.map